import {
  Component, ChangeDetectionStrategy, Input, contentChildren,
} from '@angular/core'
import { FooterLinkComponent } from './footer-link/footer-link.component'
import { CommonModule } from '@angular/common'
import { RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components'

@Component({
  selector: 'footer[kb-footer]',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterOrExternalLinkDirective],
})
export class FooterComponent {
  @Input({ required: true }) public metaNavigationLabel!: string

  protected links = contentChildren(FooterLinkComponent)
}
